import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { UserModel } from './../shared/model/userModel';
import { SessionModel } from './entities/sessionModel';
import { AbstractSessionService } from './abstract-session.service';
import { LoginAction, LogoutAction } from '../appState/app.actions';
import { AppState } from '../appState/appStateStore.module';
import { LoginData } from './entities/LoginModel';
import { QuestionModel } from './entities/QuestionModel';

@Injectable()
export class SessionServiceMock implements AbstractSessionService {
  isTimerRunning: boolean;

  constructor(private store: Store<AppState>) {}

  login(user: UserModel): Observable<boolean> {
    const payload: LoginData = {
      username: user.username,
      passwordNeedsChange: { PasswordNeedsChange : false, Reason: ''},
      token: 'token',
      pinRequired: false,
      isIdleRunning: true
    };

    if (user && user.username === '123456789' && user.password === 'geheim1234') {
      this.store.dispatch(new LoginAction( payload));
      return Observable.of( true);
    } else if (user && user.username === '123456780' && user.password === 'geheim1234') {
      this.store.dispatch(  new LoginAction(  { ...payload,
                    passwordNeedsChange : {
                      PasswordNeedsChange: true,
                      Reason: 'Das Passwort muss geändert werden, weil ...' }
                 }
              ));
      return Observable.of( true);
    } else {
       return Observable.of( false);
    }
  }

  getSession(): Promise<SessionModel> {
    return new Promise<SessionModel>((resolve, reject) => {
      this.store.take(1).subscribe(s => {
        if (!s.app.session.user || !s.app.session.token) {
          reject('Keine gültige Anmeldung!');
        } else {
          resolve(s.app.session);
        }
      });
    });
  }

  logout() {
    this.store.dispatch( new LogoutAction());
  }

  getQuestion(username: string): Observable<QuestionModel> {
    var qm = new QuestionModel();
    qm.QuestionText = 'vier plus drei ='
    qm.Token = "token";
    return Observable.of(<QuestionModel> qm);
  }

  getVersion(): Observable<string> {
    return Observable.of(<string> '1.0.x.x');
  }

  activateIdle(): void  {
    this.isTimerRunning = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/session/session.serviceMock.ts